import { isCasinoSingleViewRoute } from 'utils/casino/route';

export const UtilsGlobalCasino = {
  isCasinoSingleViewRoute
};
